$ = require 'jquery'
ApiAjax = require 'network/api-ajax'
HeaderExperimentDetails = require 'views/header/header-experiment-details'
HeaderVersionPicker = require 'views/header/header-version-picker'
l = require 'lib/localize'
PopOver = require 'views/lib/pop-over'
React = require 'react'
simpleTest = require 'lib/experiments/simple-test'
template = require 'views/templates/header_channel_picker'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'

module.exports = class HeaderChannelPicker extends View
  CHANNELS: ['stable', 'beta', 'alpha']

  viewTitleKey: 'switch channels'

  events:
    'click .js-select': 'selectChannel'
    'click .js-select-dev': 'showDev'
    'click .js-remove-cookie': 'removeCookie'
    'click .js-view-exp-details': 'viewExperimentDetails'
    'click .js-remove-all-exps': 'removeAllExperiments'

  initialize: ->
    channels = @model.get('channels')
    @channels =
      for name in @CHANNELS when name in channels.allowed
        name: name
        displayName: Util.capitalize(name)
        active: name == channels.active
    @isDev = channels.dev

  selectChannel: (e) ->
    newChannel = e.target.name
    ApiAjax
      url: '/1/members/me/channels/active'
      type: 'PUT'
      data:
        value: newChannel
      success: =>
        @model.get('channels').active = newChannel
        PopOver.hide()
        document.location.reload()

  removeCookie: (e) ->
    Util.stop(e)
    $.cookie('head', null, { path: '/' })
    @render()

  removeAllExperiments: (e) ->
    Util.stop(e)

    for experimentName of window.abTests
      $.cookie("force_#{experimentName}", null, { path: '/', expires: -1 })

    document.location.reload()

  render: ->
    cookie = !!$.cookie('head')
    version = window.TrelloVersion
    tests = _.chain(window.abTests)
    .pairs()
    .map ([testName, config]) ->
      config = simpleTest(testName)
      {
        name: testName
        inExperiment: config.inExperiment
        selectedVariation: config.get('variation')
      }
    .sortBy (entry) -> entry.name.toLowerCase()
    .value()

    @$el.html(
      template({
        @channels,
        cookie,
        version,
        dev: @isDev,
        tests
      })
    )
    @

  viewExperimentDetails: (e) ->
    Util.stop(e)

    PopOver.pushView
      getViewTitle: -> l ['view title', 'experiment config']
      reactElement: React.createElement HeaderExperimentDetails,
        key: 'header-experiment-details'
        experimentName: @$(e.currentTarget).attr('data-name')

    return

  showDev: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: HeaderVersionPicker

    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-channel-picker.coffee